export enum CoinsTypes {
  GET_ALL_DATA_COINS = 'GET_ALL_DATA_COINS',
  LOGOUT = 'LOGOUT'
}
